import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportService {
  private _baseUrl = '/api/import';

  constructor(private http: HttpClient) { }

  importFile(formData: FormData): Observable<any> {
    return this.http.post(this._baseUrl, formData, { responseType: 'text' });
  }
}
